import React, { useEffect, useContext } from 'react';

import ResultsComponent from '../../../../components/ResultsComponent';

import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { InfusionAddedDrugContext } from '../../../../contexts/InfusionProvider/InfusionAddedDrugProvider';
import { ResultsContext } from '../../../../contexts/ResultsProvider';

interface InfusionAddedDrugResultScreenProps {
 description?: string;
}

function InfusionAddedDrugResultScreen({
 description,
}: InfusionAddedDrugResultScreenProps): React.ReactElement {
 const {
  setNextButtonAction,
  setNextButtonText,
  setBackButtonText,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { sixthScreenRedirect, homeRedirect } = useContext(
  InfusionAddedDrugContext,
 );

 const { setHasMultipleResults } = useContext(ResultsContext);

 const setNavigationProps = () => {
  const setNextButtonProps = () => {
   setNextButtonAction(homeRedirect);
   setNextButtonText('Ferdig');
  };
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(sixthScreenRedirect);
  };
  setNextButtonProps();
  setBackButtonProps();
 };

 const setResultProps = () => {
  setHasMultipleResults(true);
 };

 useEffect(() => {
  setNavigationProps();
  setResultProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return <ResultsComponent description={description} />;
}

InfusionAddedDrugResultScreen.defaultProps = {
 description: 'Mengde',
};

export default InfusionAddedDrugResultScreen;
